import { Navigate, Route, Routes } from 'react-router-dom';
import { AppLayout } from '../../shared/components/Layout/AppLayout';
import { ProtectedRoute } from './ProtectedRoute';
import { RequireTenant } from './RequireTenant';
import { LoginPage } from '../../modules/auth/LoginPage';
import { DashboardPage } from '../../modules/dashboard/DashboardPage';
import { TenantsPage } from '../../modules/tenants/TenantsPage';
import { LinesOfBusinessPage } from '../../modules/lines-of-business/LinesOfBusinessPage';
import { LineOfBusinessDetail } from '../../modules/lines-of-business/LineOfBusinessDetail';
import { LineOfBizDashboardPage } from '../../modules/lines-of-business/LineOfBizDashboardPage';
import { ReportTemplateDetail } from '../../modules/report-templates/ReportTemplateDetail';
import { ReportTemplateSettings } from '../../modules/report-templates/ReportTemplateSettings';
import { ReportTemplateInstances } from '../../modules/report-templates/ReportTemplateInstances';
import { ReportTemplateVisibility } from '../../modules/report-templates/ReportTemplateVisibility';
import { ReportInstancesPage } from '../../modules/report-instances/ReportInstancesPage';
import { PromptsPage } from '../../modules/prompts/PromptsPage';
import { PromptSetsPage } from '../../modules/prompts/PromptSetsPage';
import { PromptSetDetail } from '../../modules/prompts/PromptSetDetail';
import { PromptFunnelStagesPage } from '../../modules/prompts/PromptFunnelStagesPage';
import { PersonasPage } from '../../modules/system/PersonasPage';
import { CategoriesPage } from '../../modules/system/CategoriesPage';
import { AIModelsPage } from '../../modules/system/AIModelsPage';
import { AIModelProvidersPage } from '../../modules/system/AIModelProvidersPage';
import { AIModelAiProvidersPage } from '../../modules/system/AIModelAiProvidersPage';
import { ProductsPage } from '../../modules/system/ProductsPage';
import { OrganizationsPage } from '../../modules/system/OrganizationsPage';
import { LineOfBizCategoriesPage } from '../../modules/tenant/LineOfBizCategoriesPage';
import { LineOfBizPersonasPage } from '../../modules/tenant/LineOfBizPersonasPage';
import { TenantOrganizationsBrandsPage } from '../../modules/tenant/TenantOrganizationsBrandsPage';
import { CompetitorBrandsPage } from '../../modules/lines-of-business/CompetitorBrandsPage';

export function AppRouter() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<ProtectedRoute />}>
        <Route element={<AppLayout />}>
          {/* Tenant-less views: the Customers page (where customers are
              managed/picked) and the Global settings catalogs — they show
              system-wide data and match the backend's `useTenantless`
              routes, so they work with no active customer. */}
          <Route path="/tenants" element={<TenantsPage />} />
          <Route path="/personas" element={<PersonasPage />} />
          <Route path="/categories" element={<CategoriesPage />} />
          <Route path="/ai-models" element={<AIModelsPage />} />
          <Route path="/ai-model-providers" element={<AIModelProvidersPage />} />
          <Route path="/ai-model-ai-providers" element={<AIModelAiProvidersPage />} />
          <Route path="/products" element={<ProductsPage />} />
          <Route path="/organizations" element={<OrganizationsPage />} />
          <Route path="/prompt-funnel-stages" element={<PromptFunnelStagesPage />} />
          {/* Every other view is tenant-scoped: with no active customer,
              RequireTenant renders a "no customer selected" state instead
              of the view, so no tenant-scoped API request is performed. */}
          <Route element={<RequireTenant />}>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/lines-of-business" element={<LinesOfBusinessPage />} />
          <Route path="/lines-of-business/:id" element={<LineOfBusinessDetail />} />
          <Route path="/line-of-biz-dashboard" element={<LineOfBizDashboardPage />} />
          {/* The standalone Report Templates list view was retired in
              favour of the sidebar dropdown + per-template sub-sections
              below. Templates are still managed via the per-id routes. */}
          <Route
            path="/report-templates/:id"
            element={<Navigate to="prompts" replace />}
          />
          <Route path="/report-templates/:id/settings" element={<ReportTemplateSettings />} />
          <Route path="/report-templates/:id/prompts" element={<ReportTemplateDetail />} />
          <Route path="/report-templates/:id/instances" element={<ReportTemplateInstances />} />
          <Route path="/report-templates/:id/visibility" element={<ReportTemplateVisibility />} />
          <Route path="/report-instances" element={<ReportInstancesPage />} />
          <Route path="/prompts" element={<PromptsPage />} />
          <Route path="/prompt-sets" element={<PromptSetsPage />} />
          <Route path="/prompt-sets/:id" element={<PromptSetDetail />} />
          <Route path="/tenant-organizations-brands" element={<TenantOrganizationsBrandsPage />} />
          <Route path="/line-of-biz-categories" element={<LineOfBizCategoriesPage />} />
          <Route path="/line-of-biz-personas" element={<LineOfBizPersonasPage />} />
          <Route path="/competitor-brands" element={<CompetitorBrandsPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Route>
    </Routes>
  );
}
